import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { SALON_SERVICE_LOBBY_PATH } from '../config/salonApp';
import { KIOSK_MODE_DESK, setSalonKioskMode } from '../utils/salonKioskMode';

/** After salon login — stylist customer list (Passport check-ins appear after front desk confirm). */
export default function SalonTokenEntryPage() {
  useEffect(() => {
    setSalonKioskMode(KIOSK_MODE_DESK);
  }, []);
  return <Navigate to={SALON_SERVICE_LOBBY_PATH} replace />;
}
